import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { UsageService } from './usage.service';

/**
 * Times every server call for the usage report: added up per endpoint in the tracker and sent with the next batch.
 * The usage service is looked up when a call finishes, not injected: it makes calls itself, so injecting it here would
 * be circular.
 */
@Injectable()
export class UsageTimingInterceptor implements HttpInterceptor {
  constructor(private readonly injector: Injector) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const started = Date.now();
    // Recording a call can never change or fail the call itself.
    const done = (status: number) => {
      try {
        this.injector.get(UsageService).api(request.method, request.urlWithParams, Date.now() - started, status);
      } catch {
        // ignored on purpose
      }
    };
    return next.handle(request).pipe(tap({
      next: (event) => { if (event instanceof HttpResponse) done(event.status); },
      error: (error: unknown) => done(error instanceof HttpErrorResponse ? error.status : 0),
    }));
  }
}
